import React from 'react';
import Markup from '../../../../base/Markup/Markup';
import { LargeBoxCardStoryblok } from '../../../../types/storyblok';
import { Type } from '../../../../base/Type/Type';
import { Box } from '../../../../base/Box/Box';

const LargeBoxCard = ({
  heroHeading,
  heading,
  description,
}: LargeBoxCardStoryblok) => (
  <Box
    as="article"
    className="ff-border rounded border px-5 pb-15 pt-10 md:px-10 md:pb-25 md:pt-14"
    shadow
    insetBkg
    overlayOverBkg
  >
    <Box as="div" className="flex h-full flex-col justify-between">
      <Box as="div">
        <Type
          as="h3"
          className="mb-10 font-helvetica text-h2 md:mb-15 lg:mb-19"
        >
          {heroHeading}
        </Type>
        <Type as="h2" className="mb-5 text-h4">
          {heading}
        </Type>
        <Markup content={description} className="text-p1" />
      </Box>
    </Box>
  </Box>
);

export default LargeBoxCard;
